import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $("#menu-toggle").click(function(e) {
      e.preventDefault();
      $("#wrapper").toggleClass("toggled");
    });
  }
}